import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import type { AppointmentBookingService } from '../../../types';
import { useWidgetDimensions } from '../../widget-dimensions-provider';
import { ServiceCardFullPrice } from './service-card-full-price';
import { ServiceCardOverview } from './service-card-overview';

type ServiceCardContentProps = {
  service: AppointmentBookingService;
};

export const ServiceCardContent = ({ service }: ServiceCardContentProps) => {
  const { duration, name, description, price } = service;

  const { isSmallMobile } = useWidgetDimensions();

  const displayPrice = price.type !== 'hidden';

  return (
    <Container _isSmallMobile={isSmallMobile}>
      <ServiceCardOverview name={name} description={description} />
      {(displayPrice || !!duration) && (
        <ServiceCardFullPrice
          price={price}
          duration={duration}
          displayPrice={displayPrice}
        />
      )}
    </Container>
  );
};

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'service-card-content',
    element: 'container'
  })
})<{
  _isSmallMobile: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  gap: 4px;
  min-width: ${({ _isSmallMobile }) =>
    _isSmallMobile ? 'calc(100% - 76px)' : '200px;'};
`;
